/**
 *
 * Atlas Service Sagas
 *
 */

import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import get from 'lodash/get';
import { take, call, put } from 'redux-saga/effects';
import { notAsked, ATLAS_REQUEST, success, loading, failure } from './index';
import { atlasAccountRestrictionsRequest } from './api';

export const normalizeResponse = (results) => ({ restrictionCode: get(results, 'restrictionCode', '-') });

export function* requestFlow(apexAccountId) {
  yield put(loading(apexAccountId));

  try {
    const result = yield call(atlasAccountRestrictionsRequest, apexAccountId);
    const normalizeResults = normalizeResponse(result);
    yield put(success(normalizeResults));
  } catch (err) {
    let errorBody = err;
    if (isObject(err.response)) {
      if (isFunction(err.response.json)) {
        errorBody = yield err.response.json();
      }
      errorBody.status = err.response.status;
    } else {
      errorBody = errorBody.toString();
    }
    // The .json() method turns the response body into a promise.
    // Set status to FAILURE and pass along the error
    yield put(failure(errorBody));
  }
}

export function* atlasServiceFlow() {
  // Set the initial status
  yield put(notAsked());

  while (true) {
    // Watch for SEARCH_REQUEST to be dispatched
    const { apexAccountId } = yield take(ATLAS_REQUEST);

    // Make the request
    yield call(requestFlow, apexAccountId);
  }
}

export default [atlasServiceFlow()];



// WEBPACK FOOTER //
// ./src/services/atlasRequest/sagas.js